import { Box, useDisclosure } from '@chakra-ui/react';
import { isEmpty } from 'lodash';
import { useTranslation } from 'react-i18next';

import { QuestionMarkIcon } from 'Asset/icon';
import HeaderMobile from 'Component/header-mobile';
import { Condition } from 'Component/others';

import DrawerInfo from 'View/host-achievement-detail/section/drawer-info';
import Filter from 'View/host-achievement-detail/section/filter';
import Ranking from 'View/host-achievement-detail/section/ranking';
import TargetProgress from 'View/host-achievement-detail/section/target-progress';
import SkeletonHostAchievementDetail from 'View/host-achievement-detail/component/skeleton';
import HostAchievementDetailProvider, { useHostAchievementDetailState } from 'View/host-achievement-detail/state';
import useGetAchievementRank from 'Domain/host-achievement-detail/useGetAchievementRank';

import styles from './styles.module.css';

const HostAchievementDetail = () => {
  const { t } = useTranslation('host-achievement');
  const toggleDrawer = useDisclosure();
  const { filterState } = useHostAchievementDetailState();
  const { data: dataRank, isLoading: isLoadingRank } = useGetAchievementRank(filterState);
  const isDataLoaded = !isEmpty(dataRank);
  const userData = dataRank?.userData;
  const userProgress = dataRank?.targetProgress;
  const rankingData = dataRank?.rankingData;

  return (
    <Box>
      <HeaderMobile
        type="header-back"
        title={t('page.title')}
        rightSection={<QuestionMarkIcon color="var(--color-semantic-text)" onClick={toggleDrawer.onOpen} />}
      />
      <Box className={styles['achievement-content__container']}>
        <Filter />
        <Condition statement={isDataLoaded} fallback={<SkeletonHostAchievementDetail />}>
          <Ranking userData={userData} rankingData={rankingData} isFetching={isLoadingRank} />
          <Condition statement={!isEmpty(rankingData)}>
            <TargetProgress userProgress={userProgress} isFetching={isLoadingRank} />
          </Condition>
        </Condition>
      </Box>
      <DrawerInfo {...toggleDrawer} />
    </Box>
  );
};

const HostAchievementDetailContainer = () => <HostAchievementDetailProvider children={<HostAchievementDetail />} />;

export default HostAchievementDetailContainer;
